import { render, staticRenderFns } from "./ScreeningProcessFlags.vue?vue&type=template&id=05dfe2a6&"
import script from "./ScreeningProcessFlags.vue?vue&type=script&lang=js&"
export * from "./ScreeningProcessFlags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports